import { Component } from '@theme/component';

/**
 * A simple tab switcher used on the PDP for Description / Ingredients / How to Use / Awards.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} tabButtons
 * @property {HTMLElement[]} tabPanels
 *
 * @extends Component<Refs>
 */
class PdpTabs extends Component {
  requiredRefs = ['tabButtons', 'tabPanels'];

  /** @param {Event} event */
  handleTabClick(event) {
    const button = /** @type {HTMLElement} */ (event.target);
    const target = button.dataset.tabTarget;

    for (const tabButton of this.refs.tabButtons) {
      const isActive = tabButton === button;
      tabButton.classList.toggle('is-active', isActive);
      tabButton.setAttribute('aria-selected', String(isActive));
    }

    for (const panel of this.refs.tabPanels) {
      panel.hidden = panel.dataset.tabPanel !== target;
    }
  }
}

if (!customElements.get('pdp-tabs')) {
  customElements.define('pdp-tabs', PdpTabs);
}
